export default function charactercount(input = "", isWithoutSpace = false) {
  if (isWithoutSpace) {
    const regex = /\s/g;
    return input.replace(regex, "").length;
  }
  return input.length;
}
